import { useState } from "react";
import { Link } from "react-router-dom";
import NetworkGraph from "../../components/NetworkGraph";
import Reveal from "../../components/Reveal";
import { IconClipboard } from "../../components/Icons";

const ACCENT = "#8B90A0";

const FAQS = [
  {
    question: "Consultoria é cobrada separado do contrato MSP?",
    answer:
      "Depende do escopo. Diagnósticos simples e orientações podem estar incluídos no contrato MSP. Projetos maiores (migração, implantação de sistemas, reestruturação de rede) são orçados separadamente. Consultamos caso a caso.",
  },
  {
    question: "Vocês trabalham com empresas que nunca tiveram TI estruturada?",
    answer:
      "Sim, e é onde mais fazemos diferença. Partimos do zero, documentamos tudo e estruturamos um ambiente de TI organizado e seguro — independentemente do ponto de partida.",
  },
  {
    question: "A sepolTECH faz migração de servidor físico para nuvem?",
    answer:
      "Sim. Planejamos e executamos migrações de ambiente on-premise para nuvem (Azure, AWS, hospedagem dedicada), com minimização de downtime e risco para a operação.",
  },
  {
    question: "Após o projeto, tem suporte contínuo?",
    answer:
      "Sim. Recomendamos sempre a continuidade via contrato de Gestão de TI (MSP), que garante monitoramento e suporte contínuo após a implantação. Mas projetos avulsos também são atendidos.",
  },
];

const STEPS = [
  {
    title: "Reunião de levantamento",
    desc: "Entendemos sua realidade, necessidades e objetivos",
  },
  {
    title: "Diagnóstico e proposta",
    desc: "Apresentamos análise e plano de ação detalhado com custos",
  },
  {
    title: "Aprovação e início",
    desc: "Você aprova o escopo e definimos cronograma",
  },
  {
    title: "Execução",
    desc: "Implementação com acompanhamento e comunicação contínua",
  },
  {
    title: "Entrega e documentação",
    desc: "Projeto entregue com documentação completa e suporte pós-implantação",
  },
];

const FEATURES = [
  {
    title: "Diagnóstico de Infraestrutura",
    desc: "Mapeamos toda a infraestrutura atual: hardware, software, rede, segurança e processos",
  },
  {
    title: "Planejamento Estratégico de TI",
    desc: "Definimos um roadmap tecnológico alinhado ao crescimento e objetivos do negócio",
  },
  {
    title: "Migração para Nuvem",
    desc: "Planejamos e executamos migrações para cloud com minimização de risco e downtime",
  },
  {
    title: "Implantação de Sistemas",
    desc: "Instalação, configuração e documentação de novos sistemas e plataformas",
  },
  {
    title: "Avaliação de Segurança",
    desc: "Diagnóstico de vulnerabilidades e recomendações de segurança para o ambiente",
  },
  {
    title: "Documentação Técnica",
    desc: "Toda a infraestrutura documentada — para que você nunca dependa só da memória do técnico",
  },
];

export default function Consultoria() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index));
  };

  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <Link to="/servicos/servicos">Serviços</Link>
            <span>/</span>
            <span>Consultoria &amp; Projetos</span>
          </div>
          <div className="tag animate-up animate-up--d1" style={{ color: ACCENT, background: "rgba(139,144,160,.12)", borderColor: `${ACCENT}40` }}>
            <IconClipboard style={{ width: "13px", height: "13px" }} />
            Diagnóstico · Planejamento · Implantação
          </div>
          <h1
            className="animate-up animate-up--d2"
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "clamp(36px,5vw,64px)",
              fontWeight: 700,
              letterSpacing: "-.03em",
              lineHeight: "1.1",
              marginBottom: "24px",
              color: "var(--text-primary)",
            }}
          >
            Consultoria
            <br />
            <span style={{ color: ACCENT }}>&amp; Projetos de TI</span>
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "18px",
              color: "var(--text-secondary)",
              maxWidth: "560px",
              lineHeight: "1.7",
              marginBottom: "40px",
            }}
          >
            Levantamento de infraestrutura, planejamento estratégico,
            migração para nuvem e implantação de sistemas — projetos sob
            medida para a realidade e o orçamento da sua empresa.
          </p>
          <div className="hero-actions-col animate-up animate-up--d4">
            <Link to="/contato" className="btn btn-primary">
              Solicitar proposta →
            </Link>
            <Link to="/servicos/servicos" className="btn btn-outline">
              Ver todos os serviços
            </Link>
          </div>
        </div>
      </section>

      {/* ═══════════════ O QUE ESTÁ INCLUSO ═══════════════ */}
      <section className="section">
        <div className="container">
          <div className="grid-2col">
            <Reveal>
              <div className="tag" style={{ color: ACCENT, background: "rgba(139,144,160,.12)", borderColor: `${ACCENT}40` }}>
                O que está incluso
              </div>
              <h2 className="section-title" style={{ marginBottom: "28px" }}>
                O que a sepolTECH <span style={{ color: ACCENT }}>entrega</span>
              </h2>
              <div className="feature-list">
                {FEATURES.map((feature) => (
                  <div className="feature-item" key={feature.title}>
                    <div
                      className="feature-item__icon"
                      style={{ background: "rgba(139,144,160,.15)", color: ACCENT }}
                    >
                      ✓
                    </div>
                    <div>
                      <strong style={{ color: "var(--text-primary)" }}>{feature.title}</strong> —{" "}
                      {feature.desc}
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="card" style={{ padding: "32px" }}>
                <h3
                  style={{
                    fontFamily: "var(--font-display)",
                    fontWeight: 700,
                    fontSize: "18px",
                    marginBottom: "20px",
                    color: "var(--text-primary)",
                  }}
                >
                  Como funciona um projeto
                </h3>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: "20px" }}
                >
                  {STEPS.map((step, index) => (
                    <div
                      key={step.title}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "16px",
                      }}
                    >
                      <div className="step-num">{index + 1}</div>
                      <div>
                        <strong style={{ display: "block", marginBottom: "4px", color: "var(--text-primary)" }}>
                          {step.title}
                        </strong>
                        <span
                          style={{ fontSize: "14px", color: "var(--text-muted)" }}
                        >
                          {step.desc}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ FAQ ═══════════════ */}
      <section className="section section--alt">
        <div className="container" style={{ maxWidth: "780px" }}>
          <Reveal className="text-center" style={{ marginBottom: "40px" }}>
            <div className="tag" style={{ color: ACCENT, background: "rgba(139,144,160,.12)", borderColor: `${ACCENT}40` }}>
              FAQ
            </div>
            <h2 className="section-title">Dúvidas frequentes</h2>
          </Reveal>

          {FAQS.map((faq, index) => (
            <Reveal
              className={`faq-item${openFaq === index ? " open" : ""}`}
              delay={index * 0.05}
              key={faq.question}
            >
              <button
                className="faq-btn"
                onClick={() => toggleFaq(index)}
                aria-expanded={openFaq === index}
              >
                {faq.question}
                <span className="faq-btn__icon">+</span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ═══════════════ CTA ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="cta-banner">
            <h2 className="cta-banner__title">
              TI estruturada,
              <br />
              do jeito certo
            </h2>
            <p className="cta-banner__sub">
              Comece com um diagnóstico — e saiba exatamente onde sua empresa
              está e para onde deve ir.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Solicitar diagnóstico →
              </Link>
              <Link to="/servicos/servicos" className="btn btn-outline">
                Ver todos os serviços
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
